import axios from '@/axios'

const setAccount = ({commit, dispatch}, accountId) => {
  axios.get(`/v1/accounts/${accountId}`).then((response) => {
    localStorage.setItem('accountId', accountId)
    commit('SET_ACCOUNT', response.data)

    // Init Account Namespace
    dispatch('account/init', accountId, { root: true })
  }).catch((err) => {
    console.log(err)
  })
}

export default {
  setAccount
}
